import React, { useEffect, useState } from 'react';
import { Analytics } from '@vercel/analytics/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './LandingPage';
import Matcher from './Matcher';
import Login from './Login';
import InterviewCoach from './Interview';
import { supabase } from './supabaseClient';

const App = () => {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center text-white">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={
          session ? (
            <Navigate 
              to={new URLSearchParams(window.location.search).get('redirect') || `/app${window.location.search}`} 
              replace 
            />
          ) : (
            <Login />
          )
        } />
        <Route path="/app" element={<Matcher session={session} />} />
        <Route path="/interview" element={<InterviewCoach session={session} />} />
      </Routes>
	<Analytics />
    </Router>
  );
};

export default App;
